/* eslint-disable @typescript-eslint/no-unused-expressions */
import { CommonModule } from '@angular/common';
import { Component, inject, Input, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NavigationStart } from '@angular/router';
import { GtmService } from '@df/module-gtm/gtm.service';
import { OffClickDirective } from '@df/module-off-click/off-click.directive';
import { SearchComponentDef } from '@df/search/search.component.def';
import { AfterContentInitDirective } from '@df/ui/common/after-content-init.directive';
import { ScrollService } from '@df/util/service/scroll.service';
import { LocalGtmService } from '../../module/gtm/gtm.service.decorator';
import { IOffCanvasSearchTrayModalBlockDataContent } from './off-canvas-search-tray-modal.component';
import { OpenSearchOutletComponent } from './open-search-outlet.component';
@Component({
    selector: 'open-search',
    templateUrl: './open-search.component.html',
    standalone: true,
    styleUrls: ['./open-search.component.scss'],
    imports: [CommonModule, FormsModule, OpenSearchOutletComponent, OffClickDirective, AfterContentInitDirective]
})
export class OpenSearchComponent extends SearchComponentDef implements OnInit {
    @Input()
    contentBlockData?: IOffCanvasSearchTrayModalBlockDataContent;
    private scrollService = inject(ScrollService);
    private gtmService = inject(GtmService) as LocalGtmService;
    showOutlet = false;
    unlock?: () => void;

    override ngOnInit() {
        this.subscriptions.add(this.status.subscribe(() => this.detectChanges()));
        this.subscriptions.add(
            this.meta.routerEvents.subscribe(event => {
                if (event instanceof NavigationStart) {
                    this.close();
                }
            })
        );
        super.ngOnInit();
    }

    keyup(event: KeyboardEvent): void {
        if (event.key === 'Enter' || event.code === 'Enter') {
            this.input?.nativeElement.blur();
            this.goToSearch();
        }
    }

    override goToSearch(): void {
        super.goToSearch();
        this.close();
    }

    protected override onFocusChange(value: boolean): void {
        super.onFocusChange(value);
        value && this.open();
    }

    open() {
        if (!this.showOutlet) {
            this.showOutlet = true;
            this.unlock = this.scrollService.blockScroll();
            this.gtmService.searchDesign = 'open_search';
            this.detectChanges();
        }
    }

    close() {
        if (this.showOutlet) {
            this.showOutlet = false;
            this.unlock?.();
            this.gtmService.searchDesign = undefined;
            this.reset();
            this.detectChanges();
        }
    }
}
